var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9F5CA;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 20
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8,14.5h-7.4l-0.9,5.1c1.5-0.8,2.8-1.2,4.1-1.2c1,0,1.9,0.2,2.8,0.6s1.6,0.9,2.3,1.5s1.2,1.5,1.5,2.4 c0.4,0.9,0.6,1.9,0.6,2.9c0,1.5-0.3,2.9-1,4.1c-0.7,1.2-1.6,2.2-2.9,3s-2.8,1.1-4.4,1.1c-1.9,0-3.4-0.3-4.5-1s-2-1.5-2.5-2.4 c-0.5-0.9-0.7-1.7-0.7-2.3c0-0.4,0.2-0.8,0.5-1.2c0.3-0.4,0.8-0.5,1.3-0.5c0.9,0,1.5,0.5,2,1.5c0.4,0.9,1,1.6,1.7,2.2 c0.7,0.5,1.5,0.8,2.4,0.8c0.8,0,1.5-0.2,2.1-0.6c0.6-0.4,1.1-1,1.4-1.7s0.5-1.6,0.5-2.5c0-1-0.2-1.9-0.5-2.6s-0.8-1.2-1.4-1.6 s-1.3-0.5-2-0.5c-0.9,0-1.5,0.1-1.9,0.3c-0.4,0.2-0.9,0.6-1.7,1.1s-1.3,0.8-1.8,0.8c-0.5,0-1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3 c0,0,0.1-0.4,0.2-1.1l1.3-7.5c0.1-0.9,0.4-1.6,0.8-1.9c0.4-0.4,1-0.6,1.9-0.6h8.2c1.6,0,2.4,0.6,2.4,1.9c0,0.5-0.2,1-0.6,1.3 C28.2,14.3,27.6,14.5,26.8,14.5L26.8,14.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt5);
export default __webpack_public_path__ + "static/media/CT5.7309e1aacca25f9ef988009dd0119637.svg";
export { ForwardRef as ReactComponent };